
import { BoxMaintenanceViewPage } from "./view.box";
import { CloudMaintenanceViewPage } from "./view.cloud";
import { DemoMaintenanceViewPage } from "./view.demo";

import { mixin } from "@cems-eco/core/src/utils/platform";
import environment from "@/config";

export default class MaintenanceView extends mixin(environment.nexus, {
  box: BoxMaintenanceViewPage,
  cloud: CloudMaintenanceViewPage,
  demo: DemoMaintenanceViewPage,
}) {
  [key: string]: any;
}
